import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { TLojas } from "../types";
import { getLojas } from "./services";

export const actionGetLojas: any = createAsyncThunk(
  "GET_LOJAS",
  async (_, { getState }) => {
    const { getRegionais: { regionalSelected } }: any = getState();

    const { data } = await getLojas(regionalSelected)

    return data
  }
)

const lojasSlices = createSlice({
  name: "GET_LOJAS",
  initialState: {
    lojaSelected: null,
    lojaSelectedInfos: {} as TLojas | undefined,
    lojas: [] as Array<TLojas>,
    feedbackError: "",
    status: "",
  },
  reducers: {
    actionSelectLoja: (state, { payload }) => {
      state.lojaSelected = payload
      state.lojaSelectedInfos = state.lojas.find(({id}) => id === Number(payload))
    },
  },
  extraReducers: {
    [actionGetLojas.pending]: (state) => {
      state.status = "loading"
    },
    [actionGetLojas.fulfilled]: (state, { payload }) => {
      state.status = "success"
      state.lojas = payload
    },
    [actionGetLojas.rejected]: (state, payload) => {
      state.status = "failed"
      state.feedbackError = "Deu erro"
    },
  }
})

export default lojasSlices.reducer
export const { actionSelectLoja } = lojasSlices.actions